import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaUser, FaArrowRight } from "react-icons/fa";
import { userEvent } from "../controller";
import teams from "../assets/data/team";
import Loading from "../components/Loading";
import { mission } from "../controller";
import Noti from "../components/Noti";
import Pagination from "../components/Pagination/Pagination";
import harmony from "../assets/images/harmony.png";
import heart from "../assets/images/heart.png";
import myu from "../assets/images/myu.png";
import sync from "../assets/images/sync.png";
import connect from "../assets/images/connect.png";
import global from "../assets/images/global.png";
import teamData from "../assets/data/team";
// // Import team images
// import khoacongnghethongtin from "../assets/images/hinhanhteam/khoacongnghethongtin.png";
// import khoakhoahocxahoivanhanvan from "../assets/images/hinhanhteam/khoakhoahocxahoivanhanvan.png";
// import khoakinhtequantri from "../assets/images/hinhanhteam/khoakinhtequantri.png";
// import khoangoaingu from "../assets/images/hinhanhteam/khoangoaingu.png";
// import khoakythuatcongnghe from "../assets/images/hinhanhteam/khoakythuatcongnghe.png";
// import khoadulich from "../assets/images/hinhanhteam/khoadulich.png";
// import khoayduoc from "../assets/images/hinhanhteam/khoayduoc.png";
// import khoaketoantaichinh from "../assets/images/hinhanhteam/khoaketoantaichinh.png";
// import khoanghethuat from "../assets/images/hinhanhteam/khoanghethuat.png";
// // CLB imports
// import clbthoitrang from "../assets/images/hinhanhteam/clbthoitrang.png";
// import clbbongchuyen from "../assets/images/hinhanhteam/clbbongchuyen.png";
// import clbguitar from "../assets/images/hinhanhteam/clbguitar.png";
// import clbcongtacxahoi from "../assets/images/hinhanhteam/clbcongtacxahoi.png";
// import clbthethaodientu from "../assets/images/hinhanhteam/clbthethaodientu.png";
// import clbnhiepanh from "../assets/images/hinhanhteam/clbnhiepanh.png";
// import clbbongda from "../assets/images/hinhanhteam/clbbongda.png";
// import clbvannghe from "../assets/images/hinhanhteam/clbvannghe.png";
// import clbmatmadisan from "../assets/images/hinhanhteam/clbmatmadisan.png";
// import clbtruyenthongsukien from "../assets/images/hinhanhteam/clbtruyenthongsukien.png";
// import clbluathoc from "../assets/images/hinhanhteam/clbluathoc.png";
// import clbkynang from "../assets/images/hinhanhteam/clbkynang.png";
// import clbdaisuvanhien from "../assets/images/hinhanhteam/clbdaisuvanhien.png";
// import clbkythuatcongnghe from "../assets/images/hinhanhteam/clbkythuatcongnghe.png";
// import clbcongnghethongtin from "../assets/images/hinhanhteam/clbcongnghethongtin.png";
// import clbdoanhnhanbanlinh from "../assets/images/hinhanhteam/clbdoanhnhanbanlinh.png";
// import clbsuckhoeyhoc from "../assets/images/hinhanhteam/clbsuckhoeyhoc.png";
// import clbluhanh from "../assets/images/hinhanhteam/clbluhanh.png";
// import clbbartender from "../assets/images/hinhanhteam/clbbartender.png";
// import clbtiengtrung from "../assets/images/hinhanhteam/clbtiengtrung.png";
// import clbtamlyhoc from "../assets/images/hinhanhteam/clbtamlyhoc.png";
// import clbphattriensukien from "../assets/images/hinhanhteam/clbphattriensukien.png";
// import clbthuphap from "../assets/images/hinhanhteam/clbthuphap.png";
// import clbshindou from "../assets/images/hinhanhteam/clbshindou.png";
// import clbvanhocnghethuat from "../assets/images/hinhanhteam/clbvanhocnghethuat.png";
// import clbtienganh from "../assets/images/hinhanhteam/clbtienganh.png";
// import clbhanquochoc from "../assets/images/hinhanhteam/clbhanquochoc.png";
// import clbvovinam from "../assets/images/hinhanhteam/clbvovinam.png";
// import clbketoantaichinh from "../assets/images/hinhanhteam/clbketoantaichinh.png";
// import clbvothuattonghop from "../assets/images/hinhanhteam/clbvothuattonghop.png";
// import clbtaekwondo from "../assets/images/hinhanhteam/clbtaekwondo.png";
// import clbbongro from "../assets/images/hinhanhteam/clbbongro.png";
// import clbkaratedo from "../assets/images/hinhanhteam/clbkaratedo.png";
const getImagePath = (name) => {
  // Create mapping for specific names first

  // KHOA mapping
  if (name === "Harmony") {
    return harmony;
  } else if (name === "Heart") {
    return heart;
  } else if (name === "Global") {
    return global;
  } else if (name === "myU") {
    return myu;
  } else if (name === "Connect") {
    return connect;
  } else if (name === "Sync") {
    return sync;
  }
};
const initialTasks = [
  {
    id: "1",
    title: "Nhiệm vụ 01: +20 điểm",
    description: (
      <>
        <b>
          Quay một đoạn clip ngắn (vlog, phỏng vấn, review…) chia sẻ trải
          nghiệm, cảm nghĩ, hoặc những điều bạn yêu thích về Đại học Văn Hiến,
          có thể xoay quanh: cơ sở vật chất, môi trường học tập, giảng viên,
          hoạt động sinh viên và các sự kiện mà bạn tham gia...
        </b>
        <br />
        Yêu cầu:
        <ul className="list-disc ml-5 mt-2 mb-2 text-base">
          <li>Thời lượng clip: 1–3 phút</li>
          <li>
            Chất lượng clip: Hình ảnh rõ nét, ánh sáng đầy đủ, âm thanh rõ ràng.
          </li>
          <li>
            Nội dung: Là những trải nghiệm cá nhân, chân thực tại giảng đường
            hoặc trong các hoạt động gắn với Văn Hiến.
          </li>
          <li>
            Kênh đăng tải: Clip cần được đăng tải công khai tại 1 trong các nền
            tảng mạng xã hội cá nhân: Facebook, Tiktok, Instagram, Youtube.
          </li>
          <li>
            Bài đăng đi kèm hashtag: <b>#VHU #DaihocVanHien #VanHientrongtim</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
  {
    id: "2",
    title: "Nhiệm vụ 02: +10 điểm",
    description: (
      <>
        <b>
          Chụp và đăng tải một bức ảnh check-in tại Đại học Văn Hiến chia sẻ
          trải nghiệm, cảm nghĩ, hoặc những điều bạn yêu thích về Đại học Văn
          Hiến, có thể xoay quanh: cơ sở vật chất, môi trường học tập, giảng
          viên, hoạt động sinh viên và các sự kiện mà bạn tham gia...
        </b>
        <br />
        Yêu cầu:
        <ul className="list-disc ml-5 mt-2 mb-2 text-base">
          <li>Hình ảnh rõ ràng, sắc nét và đạt chất lượng tốt.</li>
          <li>
            Caption thể hiện được những chia sẻ, cảm nghĩ, tình cảm với VHU.
          </li>
          <li>
            Hình thức: có thể là ảnh tự chụp, tự thiết kế, vẽ tay, hoặc sáng tạo
            bất kỳ có liên quan đến Đại học Văn Hiến
          </li>
          <li>
            Kênh đăng tải: Hình ảnh và nội dung cần được đăng tải công khai tại
            1 trong các nền tảng mạng xã hội cá nhân: Facebook, Tiktok,
            Instagram, YouTube.
          </li>
          <li>
            Bài đăng đi kèm hashtag: <b>#VHU #DaihocVanHien #VanHientrongtim</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
  {
    id: "3",
    title: "Nhiệm vụ 03: +5 điểm",
    description: (
      <>
        <b>
          Chia sẻ những khoảnh khắc đáng nhớ của cá nhân hoặc cùng bạn bè, đồng
          nghiệp, giảng viên tại lớp học, câu lạc bộ hoặc trong các hoạt động,
          sự kiện, không gian của Đại học Văn Hiến.
        </b>
        <br />
        Yêu cầu:
        <ul className="list-disc ml-5 mt-2 mb-2 text-base">
          <li>
            Chất lượng hình ảnh: Rõ nét, phù hợp với tinh thần và tiêu chí của
            chương trình.
          </li>
          <li>
            Kênh đăng tải: Hình ảnh và nội dung cần được đăng tải công khai tại
            1 trong các nền tảng mạng xã hội cá nhân: Facebook, Tiktok,
            Instagram, Youtube.
          </li>
          <li>
            Bài đăng đi kèm hashtag: <b>#VHU #DaihocVanHien #VanHientrongtim</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
  {
    id: "4",
    title: "Nhiệm vụ 04: +2 điểm",
    description: (
      <>
        <b>
          Chia sẻ ở chế độ công khai các bài đăng từ các kênh mạng xã hội của
          Đại học Văn Hiến (Fanpage, Zalo, Tiktok, Website…) lên các tài khoản
          mạng xã hội cá nhân của bạn.
        </b>
        <br />
        Yêu cầu:
        <ul className="list-disc ml-5 mt-2 mb-2 text-base">
          <li>Bài đăng ở chế độ công khai</li>
          <li>
            Bài đăng đi kèm hashtag: <b>#VHU #DaihocVanHien #VanHientrongtim</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
];

export default function TeamPage() {
  const navigate = useNavigate();
  const [tasks, setTasks] = useState(initialTasks);
  const [openTask, setOpenTask] = useState(tasks[0].id);
  const [isLoading, setIsLoading] = useState(true);
  const [info, setInfo] = useState({});
  const [submitStatus, setSubmitStatus] = useState(false);
  const [submissions, setSubmissions] = useState([]);
  const [submissionLoading, setSubmissionLoading] = useState(false);
  const [isClosed, setIsClosed] = useState(false);

  // Pagination state for submissions
  const [submissionPagination, setSubmissionPagination] = useState({
    page: 1,
    limit: 10,
    totalCount: 0,
    totalPages: 0,
  });

  useEffect(() => {
    // scroll to top when component mounts
    window.scrollTo(0, 0);

    // Hàm kiểm tra thời gian đóng/mở
    const checkCloseTime = () => {
      const now = new Date();
      // Đóng từ 23:59:00 ngày 19/10/2025
      const closeTime = new Date(2025, 9, 19, 23, 59, 0, 0); // Tháng 10 là 9 (JS month 0-based)
      if (now >= closeTime) {
        setIsClosed(true);
      } else {
        setIsClosed(false);
      }
    };

    checkCloseTime(); // Kiểm tra ngay khi vào trang

    // Thiết lập interval kiểm tra mỗi phút
    const interval = setInterval(checkCloseTime, 20 * 1000);

    return () => clearInterval(interval);
  }, []);

  const fetchSubmissions = async (page = 1, limit = 2) => {
    try {
      setSubmissionLoading(true);
      const response = await mission.getSubmissionById({
        userEventId: info.id,
        page: page,
        limit: limit,
      });

      if (response) {
        setSubmissions(
          response.submissions?.rows || response.submissions || []
        );
        const totalCount = response.totalCount || 0;
        const totalPages = Math.ceil(totalCount / limit);

        setSubmissionPagination({
          page: page,
          limit: limit,
          totalCount: totalCount,
          totalPages: totalPages,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSubmissionLoading(false);
    }
  };

  const fetchUserEvent = async () => {
    const phone =
      sessionStorage.getItem("phoneNumber") ||
      localStorage.getItem("phoneNumber");
    if (!phone) return;

    try {
      setIsLoading(true);
      const response = await userEvent.getUserEvent({
        phoneNumber: phone,
        event: "minigameVhu30",
      });
      if (response) {
        // console.log("User events fetched successfully:", response);
        const teamName =
          teams.find((team) => team.key === response?.userEvent?.team)?.name ||
          "Unknown Team";
        const captain = teams.find(
          (team) => team.key === response?.userEvent?.team
        )?.captain;
        setInfo({
          name: response?.userEvent?.name || "User",
          mail: response?.user365?.mail || "",
          photo: response?.user365?.photo || "",
          teamKey: response?.userEvent?.team || "",
          teamName: teamName,
          teamSlogan:
            teams.find((team) => team.key === response?.userEvent?.team)
              ?.slogan || "Team Slogan",
          captainName: captain,
          totalScore: response?.result?.score + response?.result?.fbScore || 0,
          mission1Score: response?.result?.mission1Score || 0,
          mission2Score: response?.result?.mission2Score || 0,
          mission3Score: response?.result?.mission3Score || 0,
          mission4Score: response?.result?.mission4Score || 0,
          fbScore: response?.result?.fbScore || 0,
          id: response?.userEvent?.id || "",
        });
      }
    } catch (error) {
      console.error("Error fetching user events:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserEvent();
  }, []);

  useEffect(() => {
    if (!info.id) return;
    fetchSubmissions(submissionPagination.page, submissionPagination.limit);
  }, [info.id]);

  // Handle pagination change
  const handleSubmissionPageChange = (newPage) => {
    setSubmissionPagination((prev) => ({
      ...prev,
      page: newPage,
    }));
    fetchSubmissions(newPage, submissionPagination.limit);
  };

  const handleInputChange = (id, value) => {
    setTasks((tasks) =>
      tasks.map((task) => (task.id === id ? { ...task, input: value } : task))
    );
  };

  const handleSubmit = async (id) => {
    if (isClosed) {
      alert("Đã hết thời gian nộp bài. Hệ thống đã đóng nhận bài thi!");
      return;
    }
    try {
      setIsLoading(true);
      const result = await mission.createSubmission({
        userEventId: info.id,
        mission: Number(id),
        link: tasks.find((task) => task.id === id).input,
      });
      if (result.message === "Submission created successfully") {
        setSubmitStatus(true);
        setTasks((tasks) =>
          tasks.map((task) => (task.id === id ? { ...task, input: "" } : task))
        );
        // Refresh submissions after successful submit and reset to first page
        // setSubmissionPagination((prev) => ({ ...prev, page: 1 }));
        fetchSubmissions(1, submissionPagination.limit);
      } else {
        throw new Error(result.message || "Failed to submit task");
      }
    } catch (error) {
      console.error("Error submitting task:", error);
      alert(error.message || "Failed to submit task");
    } finally {
      setIsLoading(false);
    }
  };

  const getMissionName = (mission) => {
    return `Nhiệm vụ ${mission}`;
  };

  const getStatusText = (status) => {
    switch (status) {
      case "approved":
        return "Đã duyệt";
      case "pending":
        return "Chờ duyệt";
      case "rejected":
        return "Từ chối";
      default:
        return status;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "approved":
        return "text-green-600 bg-green-100";
      case "pending":
        return "text-yellow-600 bg-yellow-100";
      case "rejected":
        return "text-red-600 bg-red-100";
      default:
        return "text-gray-600 bg-gray-100";
    }
  };

  const getPoints = (mission, status) => {
    if (status !== "approved") return 0;
    const pointsMap = {
      1: 20,
      2: 10,
      3: 5,
      4: 2,
    };
    return pointsMap[mission] || 0;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <div className="min-h-screen bg-[#0043D3] p-6 font-montserrat">
      {/* {isClosed && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
          <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md text-center">
            <h2 className="text-2xl font-bold text-red-600 mb-4">
              ĐÃ ĐÓNG NHẬN BÀI
            </h2>
            <p className="text-lg text-gray-700">
              Đã hết thời gian nộp bài. Hệ thống đã đóng nhận bài thi lúc 23:59
              hôm nay.
              <br />
              Xin cảm ơn bạn đã tham gia!
            </p>
          </div>
        </div>
      )} */}
      {submitStatus && (
        <Noti
          message={<span>Đã gửi kết quả nhiệm vụ thành công!</span>}
          onClose={() => setSubmitStatus(false)}
        ></Noti>
      )}
      {isLoading ? (
        <Loading></Loading>
      ) : (
        <>
          <div className="w-11/12 mx-auto flex justify-between items-center">
            <button className="border  border-[#14FFFF] bg-gradient-to-r from-[#001FBA] to-[#052FFF] text-white rounded-md px-6 max-md:px-2 py-2 font-semibold hover:bg-white hover:text-[#0253e1] transition">
              <a href="/user/events" className="max-md:text-xs leading-none">
                QUAY LẠI TRANG CHỦ
              </a>
            </button>
            <div className="flex items-center gap-2 text-white text-base">
              <span>{sessionStorage.getItem("mail")}</span>
              <span className="text-xl">
                <FaUser />
              </span>
            </div>
          </div>

          {/* Club Info */}
          <div className="w-11/12 mx-auto rounded-3xl px-6 py-10 shadow-lg">
            <div className="gap-12 mt-12 grid grid-cols-5 max-md:grid-cols-1 items-center ">
              <img
                alt="Club Card"
                className="rounded-2xl drop-shadow-xl object-cover max-h-[600px] col-span-2 max-md:col-span-3 max-md:w-full"
                style={{ objectPosition: "center" }}
                loading="lazy"
                src={getImagePath(info?.teamKey)}
              />
              <div className="text-white mt-4 col-span-3 text-start">
                {/* <h1 className="text-9xl leading-[1] font-bold bg-gradient-to-r border-stone-50 border-[#FF7E22] from-[#FFD942] to-[#FF7E22] text-transparent bg-clip-text drop-shadow-sm text-center">
                {info?.teamName}
              </h1> */}
                {/* <img
                src={
                  info?.teamKey === "Đội Harmony"
                    ? HHH
                    : info?.teamKey === "Đội Heart"
                    ? VHE
                    : info?.teamKey === "Đội House"
                    ? FMCG
                    : Aurora
                }
                alt="Club Card"
                className=" max-w-[400px] max-md:w-full mx-auto rounded-2xl drop-shadow-xl object-cover col-span-2"
                style={{ objectPosition: "center" }}
                loading="lazy"
              /> */}
                <h1 className="text-6xl max-md:text-3xl font-bold leading-normal bg-gradient-to-r from-[#FFD942] to-[#FF7E22] text-transparent bg-clip-text">
                  {info?.teamName}
                </h1>

                <div className="mt-4 text-xl space-y-2">
                  {/* <div>
                  <b>Đội trưởng:</b> {info?.captainName}
                </div>
                <div>
                  <b>Slogan:</b> {info?.teamSlogan}
                </div> */}
                  {/* <div className="w-full border-b border-gray-400"></div> */}
                  <div>
                    <b>Tên người chơi:</b> {info?.name}
                  </div>
                  {/* <div>
                    <b>TỔNG ĐIỂM NHIỆM VỤ:</b> {info?.totalScore}
                  </div>
                  <div className="flex text-base items-center w-full gap-4 flex-wrap">
                    <div>
                      <span> Nhiệm vụ 1:</span> {info?.mission1Score}
                    </div>
                    <div>
                      <span> Nhiệm vụ 2:</span> {info?.mission2Score}
                    </div>
                    <div>
                      <span> Nhiệm vụ 3:</span> {info?.mission3Score}
                    </div>
                    <div>
                      <span> Nhiệm vụ 4:</span> {info?.mission4Score}
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="w-full  flex-col items-center mt-6 text-center">
              <h2 className="uppercase text-2xl font-bold text-[#FF9500]">
                Thông tin đội
              </h2>
              <p className="text-white mt-2 text-lg">
                Đội Trưởng:{" "}
                {teamData.find((team) => team.key === info?.teamKey)?.captain}{" "}
                <br />
              </p>
              <p className="text-white mt-2 text-lg">
                Đội Phó:{" "}
                {teamData.find((team) => team.key === info?.teamKey)?.doipho}
              </p>
              <p className="text-white mt-2 text-lg">Danh Sách Thành Viên</p>
              <div className="bg-[#0192E0] px-10 py-4 rounded-md mt-4">
                <div className="grid grid-cols-3 gap-4 max-md:grid-cols-1">
                  {teamData
                    .find((team) => team.key === info?.teamKey)
                    ?.danhsachthanhvien.map((member, index) => (
                      <div key={index} className="text-white text-start">
                        - {member}
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>

          {/* Mission Board */}
          {/* <div className="bg-white/20 w-11/12 mx-auto mt-14 rounded-3xl px-12 py-10 max-md:px-6 shadow-lg">
            <h2 className="text-6xl max-md:text-3xl font-bold leading-normal text-center bg-gradient-to-r  from-[#FFD942] to-[#FF7E22] text-transparent bg-clip-text drop-shadow-sm mb-10">
              BẢNG NHIỆM VỤ
            </h2>
            <div className="flex flex-col gap-5">
              {tasks.map((task, idx) => (
                <div key={task.id} className="w-full">
                  <button
                    className={`w-full flex justify-between items-center px-4 py-3 rounded-t-xl font-bold text-lg ${
                      openTask === task.id
                        ? "bg-gradient-to-b from-[#0755FE] to-[#043398] text-white"
                        : "bg-gradient-to-b from-[#0755FE] to-[#043398] text-white rounded-xl"
                    }`}
                    onClick={() =>
                      setOpenTask(openTask === task.id ? null : task.id)
                    }
                  >
                    <span className="">{task.title}</span>
                    <span>{openTask === task.id ? "▲" : "▼"}</span>
                  </button>
                  {openTask === task.id && (
                    <div className="bg-[#0948E94D]/30 rounded-b-xl px-4 py-5 text-base text-white">
                      <div className="pb-4">{task.description}</div>
                      {!task.completed ? (
                        <>
                          <div className="flex gap-2 max-md:flex-col">
                            <input
                              type="text"
                              className="flex-1 px-3 py-2 text-black text-lg rounded-md border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#0253e1]"
                              placeholder="Nhập link kết quả nhiệm vụ"
                              value={task.input}
                              onChange={(e) =>
                                handleInputChange(task.id, e.target.value)
                              }
                              disabled={isClosed}
                            />
                            <button
                              className="bg-gradient-to-r from-[#ffc400] to-[#ff8800] text-white hover:cursor-pointer font-bold px-5 py-2 rounded-md hover:opacity-90 transition inline-flex items-center justify-center gap-2"
                              onClick={() => handleSubmit(task.id)}
                              disabled={!task.input || isClosed}
                            >
                              <span>GỬI KẾT QUẢ</span>
                              <FaArrowRight />
                            </button>
                          </div>
                          {isClosed && (
                            <div className="text-red-500 mt-3 text-lg text-center font-bold">
                              Đã hết thời gian nộp bài. Hệ thống đã đóng nhận
                              bài thi!
                            </div>
                          )}
                          <div className="text-white mt-3 text-lg text-center">
                            Bạn đã hoàn thành gửi kết quả nhiệm vụ, hãy sáng tạo
                            và cùng đồng đội hoàn thành các nhiệm bên dưới nhé{" "}
                          </div>
                        </>
                      ) : (
                        <div className="font-semibold text-green-600 mt-2">
                          Đã gửi kết quả:{" "}
                          <a
                            href={task.resultLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline break-all"
                          >
                            {task.resultLink}
                          </a>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div> */}

          {/* Submissions Table */}
          <div className="bg-white/20 w-11/12 mx-auto mt-14 rounded-3xl px-6 py-10 shadow-lg">
            <h2 className="text-3xl font-bold text-center text-[#ffc400] drop-shadow-sm mb-4">
              LỊCH SỬ NỘP BÀI
            </h2>

            {submissionPagination.totalCount > 0 && (
              <div className="text-center text-white mb-4">
                Tổng cộng: {submissionPagination.totalCount} bài nộp
              </div>
            )}

            {submissionLoading ? (
              <div className="text-center text-white text-lg py-8">
                Đang tải danh sách bài nộp...
              </div>
            ) : submissions && submissions.length > 0 ? (
              <>
                <div className="overflow-x-auto">
                  <table className="w-full bg-white rounded-lg overflow-hidden">
                    <thead className="bg-gradient-to-r from-[#0253e1] to-[#25c8ff]">
                      <tr>
                        <th className="px-4 py-3 text-left text-white font-bold">
                          Nhiệm vụ
                        </th>
                        <th className="px-4 py-3 text-left text-white font-bold">
                          Link
                        </th>
                        <th className="px-4 py-3 text-center text-white font-bold">
                          Ngày nộp
                        </th>
                        <th className="px-4 py-3 text-center text-white font-bold">
                          Trạng thái
                        </th>
                        <th className="px-4 py-3 text-center text-white font-bold">
                          Điểm
                        </th>
                        <th className="px-4 py-3 text-center text-white font-bold">
                          Ghi chú
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {submissions.map((submission, index) => (
                        <tr
                          key={submission.id}
                          className={
                            index % 2 === 0 ? "bg-gray-50" : "bg-white"
                          }
                        >
                          <td className="px-4 py-3 text-gray-800 font-medium">
                            {getMissionName(submission.mission)}
                          </td>
                          <td className="px-4 py-3">
                            <a
                              href={submission.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-600 hover:text-blue-800 underline break-all text-sm"
                            >
                              {submission.link}
                            </a>
                          </td>
                          <td className="px-4 py-3 text-center">
                            {formatDate(submission.createdAt)}
                          </td>
                          <td className="px-4 py-3 text-center">
                            <span
                              className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(
                                submission.status
                              )}`}
                            >
                              {getStatusText(submission.status)}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-center font-bold text-gray-800">
                            {getPoints(submission.mission, submission.status)}
                          </td>
                          <td className="px-4 py-3 text-center">
                            <span
                              className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(
                                submission.note
                              )}`}
                            >
                              {submission.note}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {submissionPagination.totalPages > 1 && (
                  <div className="mt-6 flex justify-center">
                    <Pagination
                      currentPage={submissionPagination.page}
                      totalPages={submissionPagination.totalPages}
                      onPageChange={handleSubmissionPageChange}
                    />
                  </div>
                )}
              </>
            ) : (
              <div className="text-center text-white text-lg">
                Chưa có bài nộp nào
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
